import React, { useEffect, useContext, useState } from "react";
import { AppContext } from "../../store/appContext";
import axios from "axios";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import Banner from "../../components/banner/banner";
import WebLoader from "../../components/webLoader/WebLoader";
import "./immobilienPrivate.scss";
import ServiceDescription from "../../components/serviceDescription/serviceDescription";
import { Slide } from "react-awesome-reveal";

const ImmobilienPrivate = () => {
  const {
    state: { baseUrl, immobielienPrivate, lang },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(immobielienPrivate).length > 0;
  const [cardOpenedData, setCardOpenedData] = useState(false);

  useEffect(() => {
    axios.get(`${baseUrl}immobielien-private`).then((response) => {
      dispatchAction("setImmobielienPrivateData", response?.data?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Find all span elements inside a div with class "page-container" that have style="color: white;"
    const spans = document.querySelectorAll('.page-container span[style="color: white;"]');
    // Add a class to each of these spans
    spans.forEach(span => {
      span.classList.add('white-text');
    });
     // Find all span elements that have style="color: rgb(212, 185, 123);"
     const goldSpans = document.querySelectorAll(
      ' span[style="color: rgb(212, 185, 123);"]'
    );
    // Add a class to each of these spans
    goldSpans.forEach((span) => {
      span.classList.add("gold-text");
    });
  }, [immobielienPrivate, cardOpenedData]);

  const renderImmobielienList = () => {
    return (
      <div className="page-container" id="page-container">
        <h2
          className="title"
          dangerouslySetInnerHTML={{
            __html:
              immobielienPrivate.immobielien_private.header["title_" + lang],
          }}
        />
        <div className="immobielien-private-body">
          {immobielienPrivate.immobielien_private.data.map((item, i) => {
            return (
              <Slide direction="left" duration={1000} triggerOnce={true} fraction={0.2}>

              <div key={`immobielien-private-card-${i}`} className="card" onClick={()=>setCardOpenedData(item)}>
                <img
                  src={item.carosel_images[0]}
                  alt="immobielien-private-image"
                />
                <div className="card-content">
                  <h3
                    className="card-title"
                    dangerouslySetInnerHTML={{
                      __html: item["title_" + lang],
                    }}
                  />
                  <p
                    className="card-desc"
                    dangerouslySetInnerHTML={{
                      __html: item["description_" + lang],
                    }}
                  />
                </div>
              </div>
              </Slide>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <WebLoader isLoading={!isDataReady} />
      <div className="immobielien-private-page page">
      {immobielienPrivate && isDataReady && (
        <React.Fragment>
          {
            <Banner
              mediaUrl={immobielienPrivate.banners[0].path}
              title={immobielienPrivate.banners[0]["title_" + lang]}
            />
          }
          {!cardOpenedData? renderImmobielienList(): <ServiceDescription data={cardOpenedData} close={()=>{setCardOpenedData(false)}} lang={lang}/>}
        </React.Fragment>
      )}
      </div>
    </React.Fragment>
  );
};

export default ImmobilienPrivate;
